import styled from "styled-components";

export const MultiUploadAreaContainer = styled.div`
    
`

export const FeedbackTotalAttached = styled.p`
  color: ${({theme}) => theme.grayLight};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.1px;
  margin-bottom: 14px;
`

export const PreviewFile = styled.div`
  width: 100%;
  margin-bottom: 24px;
  padding: 10px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({theme}) => theme.grayBackground};
  
  button {
    all: unset;
    cursor: pointer;
  }
  
  .download{
    color: ${({theme}) => theme.accent};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  
  .remove{
    width: auto;
    svg {
      margin-left: 8px;
    }
  }
`

interface DropzoneProps {
    isDragActive: boolean
}
export const Dropzone = styled.div<DropzoneProps>`
  border-radius: 6px;
  border: ${({isDragActive}) => isDragActive ? '2.5px' : '2px'} dashed ${({theme}) => theme.grayLight};
  background: ${({theme}) => theme.white};
  padding: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 300ms;
  
  p {
    color: ${({theme}) => theme.grayLight};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.1px;
    margin-left: 5px;
  }
  
  &:hover {
    cursor: pointer;
  }
`
